import { getIn } from "final-form";

export type HTMLInput = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export const focusOnFirstElement = (node: HTMLElement): void => {
	setTimeout(() => {
		(
			node.querySelector(
				'button:not(.close):not(.btn-close):not([disabled]):not([readonly]), [href], input:not([disabled]):not([readonly]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly]), [tabindex]:not(.disabled):not(.readonly):not([tabindex="-1"])',
			) as HTMLInputElement
		)?.focus();
	}, 250);
};

export const isFocusableInput = (input: HTMLInputElement) => {
	if (typeof input?.focus === "function") {
		const hiddenInput = input
			.closest(".form-control")
			?.querySelector(`.select__control+input[type="hidden"]`) as HTMLInputElement;

		if (hiddenInput) {
			hiddenInput.setAttribute("type", "text");

			hiddenInput.style.height = "0px";
			hiddenInput.style.position = "fixed";
			hiddenInput.style.top = "-100px";
			hiddenInput.style.right = "-100px";

			setTimeout(() => {
				hiddenInput.setAttribute("type", "hidden");
			}, 1000);

			return true;
		}

		return (
			(input.offsetWidth > 0 && input.offsetHeight > 0) ||
			(input.hidden && input.parentElement.tagName === "LABEL")
		);
	}

	return false;
};

export function findErrorInput(inputs: HTMLInputElement[], errors: Record<string, any>) {
	return inputs.find(
		(input: HTMLInputElement) =>
			(input.name || input.dataset.name) && getIn(errors, input.name || input.dataset.name),
	);
}
